export const height100 = 'height: 100%;';
export const width100 = 'width: 100%;';
export const heightWidth100 = `
    ${height100}
    ${width100}
`;
export const dropShadowColor = '#180096';
export const dropShadow = `filter: drop-shadow(10px 5px 4px ${dropShadowColor});`;
export const border3D = `  
    border-style: outset;
    border-width: 5px;
`;

export const displayFlex = `
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`;

export const flexColumn = 'flex-direction: column;';

// export const raisedButton = color => `
//     ${dropShadow}
//     ${border3D}
//     background: ${color};
//     border-color: ${color};
// `;

// export const hoverColor = color => `
//     :hover {
//         border-color: ${color};
//         background-color: ${color};
//     }
// `;
